import { render, staticRenderFns } from "./GroupShow.vue?vue&type=template&id=776f5472&"
import script from "./GroupShow.vue?vue&type=script&lang=js&"
export * from "./GroupShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports